import { 
  Card, 
  CardBody, 
  Box, 
  HStack, 
  Heading, 
  Stack, 
  Text, 
  Button, 
  Badge, 
  Icon,
  Divider,
  VStack
} from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router';
import { FiFileText, FiClock } from 'react-icons/fi';

export const TestCard = ({ test, order }) => {
  const navigate = useNavigate();

  const onClickHandler = () => {
    navigate(`/profile/orders/testorderdetails?orderId=${order?._id}`);
  };

  return (
    <Card
      width="100%"
      borderRadius="xl"
      variant="outline"
      transition="all 0.3s"
      borderWidth="1px"
      borderColor="gray.200"
      bg="white"
      _hover={{
        boxShadow: 'md',
        borderColor: 'teal.200',
      }}
    >
      <CardBody p={5}>
        <Stack spacing={4}>
          <HStack justify="space-between" align="flex-start">
            <VStack align="flex-start" spacing={0}>
              <Heading size="sm" fontWeight="800" color="gray.800" letterSpacing="tight">
                {order?.orderId || order?._id?.toUpperCase()}
              </Heading>
              <Text fontSize="xs" color="gray.400">
                {new Date(order?.createdAt || Date.now()).toLocaleDateString()}
              </Text>
            </VStack>
            <Badge 
              px={3} 
              py={1} 
              borderRadius="full" 
              bg="gray.100" 
              color="gray.600"
              fontSize="xs"
              fontWeight="800"
            >
              {order?.orderStatus?.toUpperCase()}
            </Badge>
          </HStack>

          <HStack spacing={3} align="center">
            <Icon as={FiFileText} color="gray.400" />
            <Text fontSize="sm" color="gray.600" fontWeight="500">
              {test?.name}
            </Text>
          </HStack>

          <Box 
            bg="teal.50" 
            p={3} 
            borderRadius="lg" 
            borderWidth="1px" 
            borderColor="teal.100"
          >
            <HStack spacing={3}>
              <Icon as={FiClock} color="teal.500" />
              <Text fontSize="sm" color="teal.700" fontWeight="700">
                {order?.appointmentDate || order?.paymentDetails?.appointmentDate || 'N/A'} | {order?.appointmentTime || order?.paymentDetails?.appointmentTime || 'N/A'}
              </Text>
            </HStack>
          </Box>

          <HStack spacing={2} align="center">
            <Box w={1.5} h={1.5} borderRadius="full" bg="gray.400" />
            <Text fontSize="sm" color="gray.500">
              {test?.name}
            </Text>
          </HStack>

          <Divider borderColor="gray.100" />

          <HStack justify="space-between" align="center">
            <HStack spacing={1}>
              <Text color="gray.400" fontSize="sm">Total Paid:</Text>
              <Text fontWeight="800" fontSize="lg" color="gray.800">
                ₹{order?.price || test?.price}
              </Text>
            </HStack>
            <Button 
              size="md" 
              variant="outline" 
              colorScheme="teal" 
              borderRadius="full"
              px={8}
              onClick={onClickHandler}
              fontWeight="bold"
            >
              Details
            </Button>
          </HStack>
        </Stack>
      </CardBody>
    </Card>
  );
};
